<template>
  <pending-review
    v-if="isDisplayPendingReviewInsteadOfFailedAssessment"
    :company-type="companyType"
    :company-name="brokerName"
  />
  <layout v-else>
    <!-- <img
      v-if="brokerLogo"
      class="h-11 w-auto mx-auto md:hidden my-6"
      :src="brokerLogo"
      alt="broker logo"
    /> -->
    <h1 class="header-text text-center">Incomplete Assessment</h1>
    <p class="mb-6 flex items-start text-dark-gray md:mb-8">
      <img
        src="@/assets/info-icon.svg"
        alt="info icon"
        class="relative top-px mr-2 inline"
      />{{ totalIncomplete }} of {{ brokerName }}'s requirements are incomplete
    </p>
    <p class="mb-6 text-dark-gray md:mb-8">
      The connection process will be complete when {{ companyName }} can pass
      all of {{ brokerName }}'s requirements. You can view any status updates
      here or within your Carrier Portal.
    </p>
    <!-- <p class="text-dark-gray mb-4">
      {{ totalIncomplete == 1 ? 'Requirement' : 'Requirements' }}
    </p>
    <div v-for="(rule, index) in incompleteRules" :key="rule">
      <div class="flex gap-2" :class="{'mb-6 md:mb-8': (index === totalIncomplete - 1)}">
          <p class="text-body-color">
            {{rulesSyntax[rule]}}
          </p>
          <p class="incomplete-status">Incomplete</p>
      </div>
      <div v-if="index !== (totalIncomplete - 1)" class="my-4 mb:my-6 border-b-2 border-light-gray"></div>
    </div> -->
    <div
      v-if="!skipShowFailedRulesToCarriers"
      class="mb-6 flex w-full flex-col gap-4"
    >
      <div
        v-for="(classification, index) in incompleteRules"
        :key="`${classification?.name}-${index}`"
        class="rounded-md border border-light-gray p-2"
      >
        <p class="mb-1 text-base text-dark-gray">
          {{ classification?.name }}
        </p>
        <p class="mb-1.5 text-xs text-dark-gray">Incomplete Rules</p>
        <p class="mb-2 text-xxs text-dark-gray">
          Please instruct your insurance agency to email your COI to
          <a
            class="text-yellow-500 underline"
            href="mailto:insurance@certs.highway.com"
            >insurance@certs.highway.com</a
          >
        </p>
        <div class="flex flex-col gap-2">
          <div
            v-for="(rule, idx) in classification?.rules"
            :key="`${classification?.name}-${index}-${idx}`"
            class="flex justify-between gap-4"
          >
            <p class="flex-1 pt-1 text-xs text-body-color">
              <span v-if="showRuleLabels">{{
                syntaxData?.[classification?.id]?.[rule?.rule]?.label
              }}</span>
              <span
                v-else
                class="loading-gradient relative -top-1 block w-full rounded-md bg-light-gray py-1 text-transparent"
                >Loading...</span
              >
            </p>
            <p class="incomplete-status">Incomplete</p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="mb-6 flex w-full flex-col gap-4"
    >
      <div class="rounded-md border border-light-gray p-2">
        <p class="mb-1 text-base text-dark-gray">Incomplete Rules</p>
        <!-- <p class="text-xs text-dark-gray mb-1.5"></p> -->
        <p class="mb-2 text-xxs text-dark-gray">
          Please instruct your insurance agency to email your COI to
          <a
            class="text-yellow-500 underline"
            href="mailto:insurance@certs.highway.com"
            >insurance@certs.highway.com</a
          >
        </p>
        <div class="flex flex-col gap-2">
          <div
            v-for="(rule, idx) in uniqueIncompleteRules"
            :key="`${rule}-${idx}`"
            class="flex justify-between gap-4"
          >
            <p class="flex-1 pt-1 text-xs text-body-color">
              <span v-if="showRuleLabels">{{
                uniqueSyntaxData?.[rule]?.label
              }}</span>
              <span
                v-else
                class="loading-gradient relative -top-1 block w-full rounded-md bg-light-gray py-1 text-transparent"
                >Loading...</span
              >
            </p>
            <p class="incomplete-status">Incomplete</p>
          </div>
        </div>
      </div>
    </div>
    <button-main
      v-if="['carrier', 'broker'].includes(companyType)"
      @click="$router.push('/carrier/brokers')"
    >
      Go to Carrier Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
    <button-main
      v-if="companyType == 'dispatcher'"
      @click="$router.push('/dispatcher')"
    >
      Go to Dispatcher Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
    <p class="mb-8 mt-6 text-xxs text-body-color md:mt-8">
      Please instruct your insurance agency to email your Certificate of
      Insurance (COI) to insurance@certs.highway.com.
      <!-- <span v-if="hasIncompleteScheduledAuto" class="font-bold">Your COI must include a schedule of VINs for the Scheduled Auto policy.</span> -->
    </p>
  </layout>
</template>

<script>
import Button from '@/components/Button.vue';
import Layout from '../layouts/HoldingTankLayout.vue';
import PendingReview from './PendingReview.vue';

export default {
  name: 'Held For Incomplete Rules Assessment',
  components: {
    'button-main': Button,
    Layout,
    PendingReview,
  },
  props: {
    companyType: String,
    companyName: String,
    loading: Boolean,
    failedRules: {
      type: Array,
      default: () => [],
    },
    uniqueFailedRules: Array,
    incompleteRules: {
      type: Array,
      default: () => [],
    },
    uniqueIncompleteRules: Array,
    totalRules: Number,
    rulesSyntax: Object,
    supportEmail: String,
    brokerLogo: String,
  },
  data() {
    return {
      showRuleLabels: false,
      syntaxData: false,
      uniqueSyntaxData: {},
      publicBrokerName: null,
    };
  },
  computed: {
    totalIncomplete() {
      return this.uniqueIncompleteRules.length;
    },
    broker() {
      return this.$store.state.company.company;
    },
    hasIncompleteScheduledAuto() {
      return this.uniqueIncompleteRules?.includes(
        'has_vin_if_auto_policy_is_scheduled_autos'
      )
        ? true
        : false;
    },
    skipShowFailedRulesToCarriers() {
      return this.$store.state.carriers?.carrierData?.connection?.issuer
        ?.skip_showing_failed_rules_to_carriers;
    },
    isDisplayPendingReviewInsteadOfFailedAssessment() {
      const { carriers } = this.$store.state || {};

      return (
        carriers?.carrierData?.connection?.issuer
          ?.is_display_pending_review_instead_of_failed_assessment ||
        carriers?.failedRulesAssessmentData
          ?.is_display_pending_review_instead_of_failed_assessment ||
        false
      );
    },
    brokerName() {
      return (
        this.broker?.legal_name ||
        this.$store.state.carriers?.carrierData?.connection?.issuer
          ?.legal_name ||
        this.publicBrokerName
      );
    },
  },
  watch: {
    incompleteRules: {
      deep: true,
      handler() {
        let self = this;
        let rVal = {};
        self.incompleteRules.forEach(async function (el) {
          let id = el?.id;
          let syntax = await self.$store.dispatch(
            'carriers/getRulesSyntaxByClassificationId',
            id
          );
          rVal[id] = syntax;
        });
        self.syntaxData = rVal;
        if (typeof self.syntaxData === 'object') {
          setTimeout(function () {
            self.showRuleLabels = true;
          }, 1000);
        }
      },
      immediate: true,
    },
    showRuleLabels: {
      deep: true,
      handler(nVal) {
        if (!nVal) return;
        let self = this;
        let newVal = self.syntaxData;
        if (Object.keys(newVal).count < 1) return;
        self.uniqueIncompleteRules.forEach((rule) => {
          Object.keys(newVal).forEach((key) => {
            if (newVal?.[key]?.[rule] && !self.uniqueSyntaxData[rule]) {
              self.uniqueSyntaxData[rule] = newVal[key][rule];
            }
          });
        });
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.brokerName) {
      this.fetchPublicBrokerName();
    }
  },
  methods: {
    async fetchPublicBrokerName() {
      const publicDetails = await this.$store.dispatch(
        'brokers/getLogoByClientId',
        localStorage.getItem('client_id')
      );
      this.publicBrokerName = publicDetails?.data?.legal_name;
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
.text-link {
  color: #e7b812;
}

.link-icon {
  position: relative;
  bottom: 1px;
}

.incomplete-status {
  padding: 4px 8px;
  background: #d6d7da;
  border-radius: 30px;
  font-size: 10px;
  width: 74px;
  height: 24px;
}
</style>
